import React, { useState, useEffect, useContext, useCallback } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import action from "./action";
import rightIcon from "../../assets/right.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import styles from "./Timeline.js";
import { getUserRole, formatDate } from "../../common/Common";
import {
  RenewalTimeLineHeader,
  OperationsTimeLineHeader,
  customerCareTimeLineHeader,
  operationsTableHeader,
} from "../../constants/Constants";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  // p: 2,
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#ff867a",
    },
  },
});

const TimeLine = (props) => {
  const { isViewTimeLine, closeViewTimeLine, timelineDetails, tableHeader } =
    props;
  const { getTimeLineDetails } = action;
  const [timeLineData, setTimeLineData] = useState({});
  const moduleMap = [
    {
      role: "Customer Care",
      key: "customercare",
    },
    {
      role: "Operations",
      key: "operations",
    },
    {
      role: "Renewal",
      key: "renewals",
    },
  ];

  useEffect(() => {
    const payload = {
      doctorid: timelineDetails.doctorId,
      clinicid: timelineDetails.clinicId,
    };
    getTimeLineDetails(payload, getTimeLineData);
  }, []);

  const getTimeLineData = (data) => {
    setTimeLineData(() => data?.result);
    // debugger;
  };

  return (
    <Modal
      open={isViewTimeLine}
      onClose={closeViewTimeLine}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid
          style={{
            height: "47px",
            margin: "0 0 25px",
            padding: "15px",
            backgroundColor: "#f0f1f5",
          }}
        >
          <span
            style={{
              height: "17px",
              fontFamily: "Lato",
              fontSize: "14px",
              fontWeight: "bold",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1,
              letterSpacing: "normal",
              textAlign: "left",
              color: "#333",
            }}
          >{`Dr. ${timelineDetails.doctorname || ""} TimeLine`}</span>
        </Grid>
        <Grid
          container
          style={{
            padding: "0 25px",
            height: "100%",
          }}
        >
          <Grid
            style={{
              //   background: "yellow",
              width: "100%",
              justifyContent: "space-between",
              display: "flex",
              padding: "15px",
            }}
          >
            <span>
              <img
                src={rightIcon}
                style={{ height: "12px", width: "12px", marginRight: "10px" }}
              />
              Profile Creation Date:{" "}
              <b>{timeLineData?.data?.doctordetails?.creationdate || "N/A"}</b>
            </span>
            <span>
              <img
                src={rightIcon}
                style={{ height: "12px", width: "12px", marginRight: "10px" }}
              />
              Profile Verification Date:{" "}
              <b>
                {timeLineData?.data?.doctordetails?.verificationdate || "N/A"}
              </b>
            </span>
          </Grid>
          <Grid
            style={{
              //   background: "yellow",
              width: "100%",
              justifyContent: "space-between",
              display: "flex",
              padding: "15px",
            }}
          >
            <span>
              <img
                src={rightIcon}
                style={{ height: "12px", width: "12px", marginRight: "10px" }}
              />
              Live Status:{" "}
              <b>
                {timeLineData?.data?.doctordetails?.accountstatus == "0"
                  ? "Pending"
                  : timeLineData?.data?.doctordetails?.accountstatus == "1"
                  ? "Verified"
                  : timeLineData?.data?.doctordetails?.accountstatus == "2"
                  ? "DisApproved"
                  : timeLineData?.data?.doctordetails?.accountstatus == "3"
                  ? "MRN Verified (Unverified)"
                  : "" || "N/A"}
              </b>
            </span>
          </Grid>

          <Grid style={{ width: "100%", paddingTop: "20px", height: "30%" }}>
            <TableContainer
              className={styles.root}
              style={{
                width: "96%",
                marginLeft: "2%",
                borderDadius: "10px",
                overflow: "auto",
                minWidth: "80%",
              }}
            >
              <Table
                className={styles.table}
                style={{
                  backgroundColor: "#ffffff",
                  border: "0.05vw solid rgba(224; 224; 224; 1)",
                }}
                size="medium"
                aria-label="a dense table"
              >
                <TableHead className="tableHead">
                  <TableRow>
                    {customerCareTimeLineHeader.map((header, index) => (
                      <TableCell
                        className={styles.header}
                        style={{
                          color: "white",
                          fontFamily: "Lato",
                          fontSize: "16px",
                          fontWeight: "bold",
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "1.33",
                          letterSpacing: "normal",
                          textAlign: "left",
                          color: "#FFFFFF",
                          zIndex: "20",
                          width: "34%",
                          maxWidth: "34%",
                        }}
                        key={index}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
            {true && (
              <Grid style={{ height: "6em", overflow: "auto" }}>
                <TableContainer
                  className={styles.root}
                  style={{
                    width: "96%",
                    marginLeft: "2%",
                    // maxHeight: "10%",
                    overFlow: "auto",
                  }}
                >
                  <Table
                    className={styles.table}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "0.05vw solid rgba(224; 224; 224; 1)",
                    }}
                    size="medium"
                    aria-label="a dense table"
                    stickyHeader
                  >
                    {true ? (
                      <TableBody
                        className={styles.tableBody}
                        style={{
                          height: "20%",
                          overflow: "auto",
                        }}
                      >
                        {timeLineData?.data?.customercare.map((e, index) => (
                          <>
                            <TableRow
                              className={styles.tableRow}
                              style={{ height: "3rem" }}
                              key={1}
                            >
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{formatDate(e.issuedate)}</span>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{`${e.fname || ""} ${e.mname || ""} ${
                                  e.lname || ""
                                }`}</span>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{e.remarks}</span>
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          marginTop: "10vh",
                          fontWeight: "bold",
                        }}
                      >
                        No Data Available
                      </p>
                    )}
                  </Table>
                </TableContainer>
              </Grid>
            )}
            <TableContainer
              className={styles.root}
              style={{
                width: "96%",
                marginLeft: "2%",
                borderDadius: "10px",
                overflow: "auto",
                minWidth: "80%",
                marginTop: "5px",
              }}
            >
              <Table
                className={styles.table}
                style={{
                  backgroundColor: "#ffffff",
                  border: "0.05vw solid rgba(224; 224; 224; 1)",
                }}
                size="medium"
                aria-label="a dense table"
              >
                <TableHead className="tableHead">
                  <TableRow>
                    {OperationsTimeLineHeader.map((header, index) => (
                      <TableCell
                        className={styles.header}
                        style={{
                          color: "white",
                          fontFamily: "Lato",
                          fontSize: "16px",
                          fontWeight: "bold",
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "1.33",
                          letterSpacing: "normal",
                          textAlign: "left",
                          color: "#FFFFFF",
                          zIndex: "20",
                          width: "34%",
                          maxWidth: "34%",
                        }}
                        key={index}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
            {true && (
              <Grid style={{ height: "6em", overflow: "auto" }}>
                <TableContainer
                  className={styles.root}
                  style={{
                    width: "96%",
                    marginLeft: "2%",
                    // maxHeight: "10%",
                    overFlow: "auto",
                  }}
                >
                  <Table
                    className={styles.table}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "0.05vw solid rgba(224; 224; 224; 1)",
                    }}
                    size="medium"
                    aria-label="a dense table"
                    stickyHeader
                  >
                    {true ? (
                      <TableBody
                        className={styles.tableBody}
                        style={{
                          height: "20%",
                          overflow: "auto",
                        }}
                      >
                        {timeLineData?.data?.operations.map((e, index) => (
                          <>
                            <TableRow
                              className={styles.tableRow}
                              style={{ height: "3rem" }}
                              key={1}
                            >
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{formatDate(e.trainingdatetime)}</span>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{`${e.fname || ""} ${e.mname || ""} ${
                                  e.lname || ""
                                }`}</span>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{e.remarks}</span>
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          marginTop: "10vh",
                          fontWeight: "bold",
                        }}
                      >
                        No Data Available
                      </p>
                    )}
                  </Table>
                </TableContainer>
              </Grid>
            )}
            <TableContainer
              className={styles.root}
              style={{
                width: "96%",
                marginLeft: "2%",
                borderDadius: "10px",
                overflow: "auto",
                minWidth: "80%",
                marginTop: "5px",
              }}
            >
              <Table
                className={styles.table}
                style={{
                  backgroundColor: "#ffffff",
                  border: "0.05vw solid rgba(224; 224; 224; 1)",
                }}
                size="medium"
                aria-label="a dense table"
              >
                <TableHead className="tableHead">
                  <TableRow>
                    {RenewalTimeLineHeader.map((header, index) => (
                      <TableCell
                        className={styles.header}
                        style={{
                          color: "white",
                          fontFamily: "Lato",
                          fontSize: "16px",
                          fontWeight: "bold",
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "1.33",
                          letterSpacing: "normal",
                          textAlign: "left",
                          color: "#FFFFFF",
                          zIndex: "20",
                          width: "34%",
                          maxWidth: "34%",
                        }}
                        key={index}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
            {true && (
              <Grid style={{ height: "6em", overflow: "auto" }}>
                <TableContainer
                  className={styles.root}
                  style={{
                    width: "96%",
                    marginLeft: "2%",
                    // maxHeight: "10%",
                    overFlow: "auto",
                  }}
                >
                  <Table
                    className={styles.table}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "0.05vw solid rgba(224; 224; 224; 1)",
                    }}
                    size="medium"
                    aria-label="a dense table"
                    stickyHeader
                  >
                    {true ? (
                      <TableBody
                        className={styles.tableBody}
                        style={{
                          height: "20%",
                          overflow: "auto",
                        }}
                      >
                        {timeLineData?.data?.renewals.map((e, index) => (
                          <>
                            <TableRow
                              className={styles.tableRow}
                              style={{ height: "3rem" }}
                              key={1}
                            >
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{formatDate(e.calldatetime)}</span>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{`${e.fname || ""} ${e.mname || ""} ${
                                  e.lname || ""
                                }`}</span>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <span>{e.remarks}</span>
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          marginTop: "10vh",
                          fontWeight: "bold",
                        }}
                      >
                        No Data Available
                      </p>
                    )}
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid style={{ padding: "35px", textAlign: "right" }}></Grid>
      </Box>
    </Modal>
  );
};

export default TimeLine;
